import styled, { css } from 'styled-components';
import { darken } from '@jiaminghi/color';

export const StyledInput = styled.input`
  position: absolute;
  overflow: hidden;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
  white-space: nowrap;
  clip: rect(0 0 0 0);

  &:checked + label::after {
    width: 8px;
    height: 8px;
  }

  &:disabled + label {
    cursor: default;
  }
`;

export const StyledLabel = styled.label`${(props) => {
  const hoverBorderColor = darken(props.styled.backgroundColor, 10);

  return css`
    margin-right: 10px;
    word-break: break-word;
    cursor: pointer;
    flex: 1;

    &::before,
    &::after {
      content: '';
      top: 50%;
      position: absolute;
      box-sizing: border-box;
      border-radius: 50%;
      transform: translateY(-50%);
      transition-property: border-color;
      transition-duration: 0.3s;
    }

    &::before {
      left: 0;
      width: 20px;
      height: 20px;
      border: 1px solid ${props.styled.backgroundColor};
      background-color: transparent;
    }

    &::after {
      width: 0;
      height: 0;
      left: 6px;
      background-color: ${props.styled.backgroundColor};
    }

    &:hover::before {
      border-color: ${hoverBorderColor};
    }

    & > p {
        margin: 0;

      & + p {
        font-size: 12px;
        opacity: 0.8;
      }
    }
  }`
}}`;
